import { aludraApi } from 'api/axios'
import { YAPPY_PAYMENT_BASE_URL } from 'Utils/constants'

const YAPPY_PAYMENT_ENDPOINT = '/payment/api/yappy/paymentlink'

export const createYappyPaymentLink = async ({
  documentId,
  documentTypeId,
  paymentTypeId,
  amount,
  phone,
}) => {
  if (!YAPPY_PAYMENT_BASE_URL) {
    throw new Error('REACT_APP_YAPPY_PAYMENT_BASE_URL is not configured')
  }
  const { data } = await aludraApi.post(YAPPY_PAYMENT_ENDPOINT, {
    AmounPay: amount,
    DocumentTypeId: documentTypeId,
    PaymentTypeId: paymentTypeId,
    DocumentId: documentId,
    Url: YAPPY_PAYMENT_BASE_URL,
    Phone: phone,
  })
  return data
}
